/**
 * Load an image URL for canvas drawing (object URLs work without crossOrigin).
 */
export function createImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.src = url;
  });
}

/**
 * Produce a cropped image File from react-easy-crop `croppedAreaPixels`.
 */
export async function getCroppedImgFile(
  imageSrc,
  pixelCrop,
  fileNameWithoutExt,
  sourceMime,
  outputSize
) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("Could not get canvas context");
  }

  const outWidth = outputSize?.width ?? pixelCrop.width;
  const outHeight = outputSize?.height ?? pixelCrop.height;

  canvas.width = outWidth;
  canvas.height = outHeight;

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    outWidth,
    outHeight
  );

  const wantsPng = sourceMime === "image/png";
  const type = wantsPng ? "image/png" : "image/jpeg";
  const ext = wantsPng ? "png" : "jpg";

  const blob = await new Promise((resolve, reject) => {
    canvas.toBlob(
      (b) => {
        if (!b) {
          reject(new Error("Could not crop image"));
        } else {
          resolve(b);
        }
      },
      type,
      wantsPng ? undefined : 0.92
    );
  });

  const safeBase =
    String(fileNameWithoutExt || "image").replace(/\s+/g, "-").slice(0, 80) ||
    "image";
  return new File([blob], `${safeBase}.${ext}`, { type });
}
